module.exports = __webpack_public_path__ + "img/about.44a86c0b.png";